var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control has-icons-right"},[_c('vue-flatpickr',{staticClass:"input",attrs:{"value":_vm.value,"config":_vm.mergedConfig,"disabled":_vm.disabled},on:{"input":_vm.updateValue}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon is-small is-right has-text-primary"},[_c('i',{staticClass:"fas fa-calendar"})])
}]

export { render, staticRenderFns }